/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import styled from "styled-components"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import FacebookLogo from "../images/facebook.svg"

import Header from "./header"
import MadeBy from "./madeby"
import "./layout.css"


const Page = styled.section`
  overflow: hidden;
`;

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <>
        <Page>
            <Header siteTitle={data.site.siteMetadata.title} />
            <main>{children}</main>
            <footer className="text-center">
                <ul className="list-inline">
                    <li className="list-inline-item">
                        <a href="impressum">Impressum</a>
                    </li>
                    <li className="list-inline-item"> | </li>
                    <li className="list-inline-item">
                        <a href="datenschutz">Datenschutz</a>
                    </li>
                    <li className="list-inline-item"> | </li>
                    <li className="list-inline-item">
                        <a href="https://www.facebook.com/pages/Friseur-Haarkonzept-Intercoiffure/527620807377157" target="_blank" rel="noreferrer">
                            <FacebookLogo width="20px" />
                        </a>
                    </li>
                </ul>

                <MadeBy/>
            </footer>
      </Page>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
